import { useEffect, useState } from "react";
import TabBox from "../../Components/Tabbox/TabBox";
import IncrementalTable from "../../Tables/DeltaHedgeSettings/Incremental/IncrementalTable";
import DecrementalTable from "../../Tables/DeltaHedgeSettings/Decremental/DecrementalTable";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import {
  DeltaHedgeMode,
  IDeltaHedgeTablesSearchParam,
} from "../../Interfaces/deltaHedgeSettings";
import { getBaseInstruments } from "../../Requests/Order/tradeTableRequests";
import { getStepInstruments } from "../../Requests/stepRequests";
import {
  getDecrementalMode,
  getIncrementalMode,
  setDecrementalMode,
  setIncrementalMode,
} from "../../Requests/deltaHedgeSettings";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { toast } from "react-toastify";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import AddIncremental from "./AddIncremental";
import AddDecremental from "./AddDecremental";
import { useAppDispatch, useAppSelector } from "../../App/hooks";
import Modal from "../../Components/Modal/Modal";
import { setHeltaHedgeSettingsAddEditModalFlag } from "../../Features/DeltaHedgeSettings/deltaHedgeSettingsSlice";
import AddIcon from "@mui/icons-material/Add";

enum ActiveTab {
  SizeIncrease,
  SizeDecrease,
  DeltaClosure,
  Decremental,
  Incremental,
  OptionOptimization,
}

const DeltaHedgeSettings = () => {
  const [activeTab, setActiveTab] = useState<ActiveTab>(ActiveTab.Decremental);
  const [searchParams, setSearchParams] = useState(
    {} as IDeltaHedgeTablesSearchParam
  );
  const [mode, setMode] = useState<DeltaHedgeMode | null>(null);
  const [loading, setLoading] = useState(false);
  const addEditModalFlag = useAppSelector(
    (store) => store.deltaHedgeSettingsSlice.addEditModalFlag
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    getModeGetter()
      .then((resp) => {
        setMode(resp);
      })
      .catch(packetErrorHandler);
  }, [activeTab]);

  function getModeGetter() {
    switch (activeTab) {
      case ActiveTab.Incremental:
        return getIncrementalMode();

      case ActiveTab.Decremental:
        return getDecrementalMode();

      default:
        return getIncrementalMode();
    }
  }

  function getModeSetter(index: number) {
    switch (activeTab) {
      case ActiveTab.Incremental:
        return setIncrementalMode(index);

      case ActiveTab.Decremental:
        return setDecrementalMode(index);

      default:
        return setIncrementalMode(index);
    }
  }

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  const tabChildren = [
    // { index: ActiveTab.SizeIncrease, title: "افزایش سایز" },
    // { index: ActiveTab.SizeDecrease, title: "کاهش سایز" },
    // { index: ActiveTab.DeltaClosure, title: "بستن دلتا" },
    { index: ActiveTab.Decremental, title: "تعدیل کاهشی" },
    { index: ActiveTab.Incremental, title: "تعدیل افزایشی" },
    // { index: ActiveTab.OptionOptimization, title: "بهینه سازی آپشن" },
  ];

  const modeChildren = [
    { index: DeltaHedgeMode.Concurrent, title: "همزمان" },
    { index: DeltaHedgeMode.OneByOne, title: "یک به یک" },
  ];

  const getTable = () => {
    switch (activeTab) {
      case ActiveTab.Incremental:
        return <IncrementalTable searchParams={searchParams} />;

      case ActiveTab.Decremental:
        return <DecrementalTable searchParams={searchParams} />;

      default:
        <></>;
    }
  };

  const getModeDesc = () =>
    tabChildren.find((t) => t.index === activeTab)?.title || "";

  const modeChangeHandler = (index: number) => {
    setMode(index);
    setLoading(true);
    getModeSetter(index)
      .then((resp) => {
        if (resp.data) toast.success(resp.msg);
        else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const getAddForm = () => {
    switch (activeTab) {
      case ActiveTab.Incremental:
        return <AddIncremental />;

      case ActiveTab.Decremental:
        return <AddDecremental />;

      default:
        return <></>;
    }
  };

  return (
    <div className="flex flex-row justify-start items-start px-5 w-full relative">
      <div
        className="bg-sky-600 rounded-full flex justify-center items-center w-11 h-11 absolute top-8 left-5 cursor-pointer"
        onClick={() => dispatch(setHeltaHedgeSettingsAddEditModalFlag(true))}
      >
        <AddIcon className="text-white" />
      </div>
      {addEditModalFlag ? (
        <Modal
          UI={
            <div className="flex flex-col justify-start items-start mx-auto gap-3">
              {getAddForm()}
            </div>
          }
          onClose={() => dispatch(setHeltaHedgeSettingsAddEditModalFlag(false))}
          modalBoxClassName="!min-w-[120px]"
        />
      ) : (
        <></>
      )}
      <div className="flex flex-col justify-start items-start gap-8 px-16">
        {loading ? <FullScreenLoading /> : <></>}
        <div className="flex flex-row justify-start items-start gap-12">
          <div className="flex flex-col justify-start items-start gap-3 w-96 p-3 border-2 border-gray-200 rounded">
            <div className="font-bold text-xs">فیلتر جستجو</div>
            <div className="flex flex-row justify-start items-start gap-5 w-full">
              <DynamicDropdown
                dropdown={{
                  name: "baseInsId",
                  placeholder: "نماد پایه",
                  extraLabel: true,
                }}
                onChange={searchParamChangeHandler}
                getData={() => getBaseInstruments()}
                value={searchParams.baseInsId}
              />

              <DynamicDropdown
                dropdown={{
                  name: "InsId",
                  placeholder: "نماد",
                  extraLabel: true,
                }}
                onChange={searchParamChangeHandler}
                getData={() => getStepInstruments()}
                value={searchParams.InsId}
              />
            </div>
          </div>

          <div className="flex flex-row justify-start items-center gap-3 w-56">
            <div className="text-xs whitespace-nowrap">{getModeDesc()}</div>
            <TabBox
              activeTab={mode || -1}
              onChange={(_, index) => modeChangeHandler(index)}
              children={modeChildren}
            />
          </div>
        </div>

        <div className="w-min">
          <TabBox
            activeTab={activeTab}
            onChange={(_, index) => setActiveTab(index)}
            children={tabChildren}
          />
        </div>
        {getTable()}
      </div>
    </div>
  );
};

export default DeltaHedgeSettings;
